import { useEffect, useRef, useState } from 'react';

import { isProgressBarWide } from './ProgressBar.utils';

export const useProgressBarWidth = () => {
    const barRef = useRef<HTMLDivElement>(null);
    const [isWide, setIsWide] = useState(false);

    useEffect(() => {
        const element = barRef.current;
        if (!element) return;

        const update = (width: number) => {
            setIsWide(isProgressBarWide(width));
        };

        update(element.getBoundingClientRect().width);

        const observer = new ResizeObserver((entries) => {
            const width = entries[0]?.contentRect.width;
            if (width !== undefined) update(width);
        });
        observer.observe(element);
        return () => observer.disconnect();
    }, []);

    return { barRef, isWide };
};
